import { PageTemplate } from "../../common/PageWrapper";

const modules = [
    {
        title: "HTML, CSS, dan Javascript untuk Web Developers",
        desc: "Pemula - 4 Modul Pembelajaran",
        img: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=600&q=80"
    },
    {
        title: "UI/UX Design",
        desc: "Pemula - 4 Modul Pembelajaran",
        img: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80"
    },
    {
        title: "Introduction to Social Media Marketing",
        desc: "Pemula - 4 Modul Pembelajaran",
        img: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80"
    },
    {
        title: "React Dasar",
        desc: "Pemula - 4 Modul Pembelajaran",
        img: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=600&q=80"
    }
];

export function NamaHalaman() {
    return (
        <PageTemplate>
            <div className="px-20 py-10">
               
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                    <h1 className="font-bold text-5xl leading-tight mb-2 md:mb-0">
                        <span className="px-2">Belajar Kapan Saja dan Di</span><br />
                        <span className="px-2">Mana Saja</span>
                    </h1>
                    <p className="text-2xl text-gray-600 max-w-2xl">
                        Ikuti pelatihan online bersama para profesional di bidangnya untuk mengasah kemampuan, memperluas wawasan, serta membangun keterampilan praktis yang relevan dengan kebutuhan industri saat ini dan masa depan.
                    </p>
                </div>
                <hr className="my-8" />
                
                {/* Module Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {modules.map((mod, idx) => (
                        <div key={idx} className="bg-white rounded-xl border border-gray-300 overflow-hidden shadow-sm flex flex-col">
                            <img src={mod.img} alt={mod.title} className="h-48 w-full object-cover" />
                            <div className="p-5 flex-1 flex flex-col">
                                <div className="font-semibold text-xl mb-2">{mod.title}</div>
                                <div className="text-gray-500 text-base mt-auto">{mod.desc}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </PageTemplate>
    );
}